import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import { Fonts, Spacings } from '@styles/index';
import Image from '@base/FutureImage';
import { useEffect, useState } from 'react';
import fetch from '@api/fetchers';
import { useRouter } from 'next/router';
import { dayTitleLeftSpacing } from '../planner-constants';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  margin-left: ${dayTitleLeftSpacing};
  padding-top: ${Spacings.SPACING_12B};
  padding-bottom: ${Spacings.SPACING_15B};
  padding-left: ${Spacings.SPACING_6B};
  padding-right: ${Spacings.SPACING_6B};
  background-color: var(--color-base-1);
  min-height: 480px;
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Title = styled(H4)`
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  margin-bottom: 2px;
  margin-top: 16px;
`;

const Description = styled(P1)`
  color: var(--color-text-primary-light);
`;

const StyledButton = styled.button`
  background-color: var(--color-base-fill);
  color: var(--color-text-tertiary);
  width: 240px;
  height: 40px;
  border-radius: 8px;
  padding: auto;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0%;
  border: 1px solid var(--color-divider);
  cursor: pointer;
  margin-top: 16px;
`;
const fetchEnrolledBatches = async (goalUID) => {
  try {
    const url = `v1/uplus/subscription/enrolled_batches/?goal_uid=${goalUID}&limit=4&offset=0`;

    const response = await fetch(url, {
      method: 'GET',
      useCamelCase: false
    });

    return response;
  } catch (error) {
    return {
      message: 'Something went wrong'
    };
  }
};

const fetchEnrolledCourses = async (goalUID) => {
  try {
    const url = `v1/uplus/subscription/enrolled_courses/?goal_uid=${goalUID}`;

    const response = await fetch(url, {
      method: 'GET',
      useCamelCase: false
    });

    return response;
  } catch (error) {
    return {
      message: 'Something went wrong'
    };
  }
};

const NoSessionCard = () => {
  const router = useRouter();
  const { goalUID, goalSlug } = router.query;
  const [hasEnrollments, setHasEnrollments] = useState({
    hasBatches: false,
    hasCourses: false
  });
  useEffect(() => {
    if (!goalUID) return;
    fetchEnrolledCourses(goalUID)
      .then((data) => {
        if (data?.results?.length) {
          setHasEnrollments((prev) => ({
            ...prev,
            hasCourses: true
          }));
        }
      })
      .catch(() => {});
  }, [goalUID]);

  useEffect(() => {
    if (!goalUID) return;
    fetchEnrolledBatches(goalUID)
      .then((data) => {
        if (data?.results?.length) {
          setHasEnrollments((prev) => ({
            ...prev,
            hasBatches: true
          }));
        }
      })
      .catch(() => {});
  }, [goalUID]);

  if (!hasEnrollments.hasBatches && !hasEnrollments.hasCourses) {
    return (
      <>
        <Wrapper className="day-title">
          <Image
            src="planner/no-enrollments.svg"
            width={80}
            height={80}
            alt="No events"
          />
          <Title>No enrolments found!</Title>
          <Description>
            Once you get enrolled to a batch or course, you will be able to see
            it in your planner
          </Description>
          <StyledButton
            color="var(--color-i-white)"
            onClick={() => {
              router.push(`/goal/${goalSlug}/${goalUID}/browse`);
            }}
          >
            Browse now
          </StyledButton>
        </Wrapper>
      </>
    );
  }

  return (
    <>
      <Wrapper className="day-title">
        <Image
          src="planner/empty-state.svg"
          width={80}
          height={80}
          alt="No events"
        />
        <Title>No sessions for the selected date</Title>
        <Description>
          Select a different date from calendar to see the sessions for that day
        </Description>
      </Wrapper>
    </>
  );
};

export default NoSessionCard;
